import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { grey } from "@mui/material/colors";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";

import { useSubscription } from "utils/useSubscription";

const styles = {
  strike: {
    textDecoration: "line-through",
    color: "#7a9f9c",
    fontSize: 22,
  },
  strikeMobile: {
    textDecoration: "line-through",
    fontSize: 20,
    color: "#FFBAAB",
  },
};

interface Props {
  plan: Plans;
}

const PlansPrice = ({ plan }: Props) => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { subscription, plans } = useContext(SubscriptionContext);
  const { getPrice } = useSubscription();

  if (!plans) return <></>;

  const originalPrice = plans[plan]?.price;
  const discountedPrice = getPrice(plan) || originalPrice;
  const hasDiscounted = originalPrice > discountedPrice;
  if (isMobileScreen) {
    return (
      <Box sx={{ fontSize: hasDiscounted ? 20 : 24 }}>
        <Box component={"span"} sx={hasDiscounted ? styles.strikeMobile : {}}>
          ${originalPrice}
        </Box>

        {hasDiscounted && <Box component={"span"}> ${getPrice(plan)}</Box>}
        <Box component={"span"} sx={{ color: grey[400] }}>
          /mo
        </Box>
        {hasDiscounted && subscription?.bannerPromoCode?.dateEnding && (
          <Typography sx={{ fontSize: 11, color: grey[400] }}>
            until {subscription?.bannerPromoCode?.dateEnding} 💥
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <>
      <Box sx={hasDiscounted ? styles.strike : {}}>
        <Box>${originalPrice}/mo</Box>
      </Box>
      {hasDiscounted && <Box>${getPrice(plan)}/mo</Box>}
      {subscription?.bannerPromoCode?.dateEnding && (
        <Typography sx={{ color: "#d95e58" }}>
          until {subscription?.bannerPromoCode?.dateEnding}
        </Typography>
      )}
    </>
  );
};

export default PlansPrice;
